import React from 'react'
import Breadcrump from './Breadcrump'



const NavBelt: React.FC<NavBeltProps> = ({ page, img, breadCrumpInfo }) => {
    return (
        <div className='h-96 w-full relative'>
            <div className="h-full w-full absolute bg-gradient-to-t from-gray-900 to-gray-500 opacity-80"></div>
            <img src={img} alt="" srcSet=""
                className='h-full w-full object-cover' />
            <div className="container mx-auto px-4 lg:px-8">
                <div className='absolute bottom-16 text-primary-light-200'>
                    <h1 className='text-4xl font-bold uppercase'>{page}</h1>
                    <Breadcrump data={breadCrumpInfo} />
                </div>
            </div>

        </div>
    )
}

export default NavBelt